import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DefaultSortingStrategy, FilteringLogic, IgxStringFilteringOperand, SortingDirection } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent} from '@infragistics/igniteui-angular/icon';
import { IgxExcelExporterService, IgxPdfExporterService } from '@infragistics/igniteui-angular/grids/core';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {GenericoService} from '../../../core/services/generico.service';
import {ClsUtil} from '../../../util/cls-util';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {ClsConfig} from '../../../util/cls-config';
import {TranslateModule} from '@ngx-translate/core';
import {ClsAnioPorcentajeAplicacion} from "../../../core/models/cls-catalogos";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import { CrearComponenteDinamicoService } from '../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-anios-porcentaje-aplicacion',
  templateUrl: './anios-porcentaje-aplicacion.component.html',
  styleUrls: ['./anios-porcentaje-aplicacion.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    MasOpcionesGridComponent,
    IgxIconComponent
  ]
})
export class AniosPorcentajeAplicacionComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridAnioPorcAplicacion', {read: IgxGridComponent, static: true})
  public gridAnioPorcAplicacion: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;

  public errorAlCargar: boolean;
  public activarBotones = false;

  // clase catalogos
  public dataAnioAplicaciones: ClsAnioPorcentajeAplicacion[] = [];
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid;
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridAnioPorcAplicacion.sortingExpressions = [
      {dir: SortingDirection.Desc, fieldName: 'Clave', ignoreCase: true, strategy: DefaultSortingStrategy.instance()}
    ]
  }

  public async cargarAniosAplicacion() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.dataAnioAplicaciones = await this.servicioGen.getURLTextAwait(`assets/json/PuCuotasVigentesImss.json`, 'json');
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridAnioPorcAplicacion.clearFilter();
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridAnioPorcAplicacion, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.ANIO_APLICACION'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridAnioPorcAplicacion.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridAnioPorcAplicacion,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.ANIO_APLICACION'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarAniosAplicacion();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public filterInput(filtro: string) {
    this.gridAnioPorcAplicacion.filteringLogic = FilteringLogic.Or;
    this.gridAnioPorcAplicacion.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridAnioPorcAplicacion.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridAnioPorcAplicacion.getRowData(rowSeleccionados[0]);
      this.gridAnioPorcAplicacion.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
